export const thousands = [
  'realConsumne',
  'paperConsumne',
  'newPlanNum',
  'runPlanNum',
  'invalidConsume',
  'pv',
  'profitPvCost',
  'clickNum',
  'clickCost',
  'activeNum',
  'activeCost',
  'registerNum',
  'registerCost',
  'createRoleNum',
  'createRoleCost',
  'newRoleNum',
  'payRole1d',
  'newRolePayCnt1d',
  'payRoleCost1d',
  'payRoleEveryCost1d',
  'createRoleMoney1d',
  'payRoleNd',
  'payROleCntNd',
  'payRoleCostNd',
  'payRoleEveryCostNd',
  'createRoleTotalMoney',
  'createRoleDays',
  'totalMoney',
  'paperConsume',
  'realConsume',
  'androidTotalMoney',
  'iosTotalMoney',
  'androidMoney',
  'iosMoney',
  'iosTransMoney',
  'reIosTransMoney'
]
